import { render, staticRenderFns } from "./ChangeCourseCampus.vue?vue&type=template&id=07177d1f&scoped=true&"
import script from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
export * from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeCourseCampus.vue?vue&type=style&index=0&id=07177d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07177d1f",
  null
  
)

export default component.exports